import http, { url } from '../../http'

const API_URL = "structure_meters"

class evaluacionIndicadoresAPI {

  async saveE(resource) {
    const response = await http(`${API_URL}/structureIndicators/save`, 'POST', resource)
    return response
  }

  async updateE(id, resource) {
    const response = await http(`${API_URL}/structureIndicators/update/${id}`, 'PUT', resource)
    return response
  }
  async updateP(id, resource) {
    const response = await http(`${API_URL}/processIndicators/update/${id}`, 'PUT', resource)
    return response
  }
  async updateR(id, resource) {
    const response = await http(`${API_URL}/resultIndicators/update/${id}`, 'PUT', resource)
    return response
  }

  async totalsE(id, year) {
    const response = await http(`${API_URL}/structureIndicators/totals/${id}/${year}`)
    return response
  }

  async totales(id, year) {
    const response = await http(`${API_URL}/totals/${id}/${year}`)
    return response
  }


  async getShowE(id) {
    const response = await http(`${API_URL}/structureIndicators/show/${id}`)
    return response
  }

  async getShowR(id) {
    const response = await http(`${API_URL}/resultIndicators/show/${id}`)
    return response
  }

  async getShowP(id) {
    const response = await http(`${API_URL}/processIndicators/show/${id}`)
    return response
  }

  async saveP(resource) {
    const response = await http(`${API_URL}/processIndicators/save`, 'POST', resource)
    return response
  }

  async totalsP(id, year) {
    const response = await http(`${API_URL}/processIndicators/totals/${id}/${year}`)
    return response
  }

  async totalsR(id, year) {
    const response = await http(`${API_URL}/resultIndicators/totals/${id}/${year}`)
    return response
  }

  async saveR(resource) {
    const response = await http(`${API_URL}/resultIndicators/save`, 'POST', resource)
    return response
  }

  async saveI(resource) {
    const response = await http(`matriz_legal_implementation/save`, 'POST', resource)
    return response
  }

  async saveImplementacion(resource) {
    const response = await http(`matriz_legal_implementation/save`, 'POST', resource)
    return response
  }

  async updateImplementacion(id, resource) {
    const response = await http(`matriz_legal_implementation/update/${id}`, 'PUT', resource)
    return response
  }

  async getAll(id, page) {
    const response = await http(`matriz_legal?page=${page}`, 'POST')
    return response
  }
  
  async getAllImplementacion(id, page) {
    const response = await http(`matriz_legal_company/${id}?page=${page}`, 'POST')
    return response
  } 

  async get() {
    const response = await http(`${API_URL}`, 'POST')
    return response
  } 

  async getE(id) {
    const response = await http(`${API_URL}/structureIndicators/index/${id}`, 'POST')
    return response
  }
  async getAllE(id, page, search) {
    const response = await http(`${API_URL}/structureIndicators/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getP(id) {
    const response = await http(`${API_URL}/processIndicators/index/${id}`, 'POST')
    return response
  }
  async getAllP(id, page, search) {
    const response = await http(`${API_URL}/processIndicators/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  }  

  async getR(id) {
    const response = await http(`${API_URL}/resultIndicators/index/${id}`, 'POST')
    return response
  }
  async getAllR(id, page, search) {
    const response = await http(`${API_URL}/resultIndicators/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getImplementacion2() {
    const response = await http(`matriz_legal_implementation/`, 'POST')
    return response
  } 

  async getImplementacion(id) {
    const response = await http(`matriz_legal_company/${id}`, 'POST')
    return response
  } 

  async getExcel(companyId, year) {
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.token) {
      return url(
        `${API_URL}/excel/${companyId}/${year}/${user.token}`
      );
    }

  }

  async getStructureExcel(companyId, year){
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.token) {
      return url(
        `${API_URL}/excelStructure/${companyId}/${year}/${user.token}`
      );
    }
  }

  async getProcessExcel(companyId, year){
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.token) {
      return url(
        `${API_URL}/excelProcess/${companyId}/${year}/${user.token}`
      );
    }
  }

  async getResultExcel(companyId, year){
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.token) {
      return url(
        `${API_URL}/excelResult/${companyId}/${year}/${user.token}`
      );
    }
  }

  async getPension(id) {
    const response = await http(`${API_URL}/company/${id}`, 'POST')
    return response
  }

    async getShow(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`matriz_legal_implementation/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  async deleteP(id) {
    const response = await http(`${API_URL}/processIndicators/delete/${id}`, 'DELETE')
    return response
  }

  async deleteR(id) {
    const response = await http(`${API_URL}/resultIndicators/delete/${id}`, 'DELETE')
    return response
  }

  async deleteE(id) {
    const response = await http(`${API_URL}/structureIndicators/delete/${id}`, 'DELETE')
    return response
  }
  
}

export default new evaluacionIndicadoresAPI()